import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class WhatsappChatsViewService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.WHATSAPP_CHATS_VIEW = '/api/whatsapp-chats-view';

        this.GET_UNREAD_COUNT_BY_PHONE_NUMBER_ID_AND_PROJECT = '/unread-count/{phoneNumberId}/project/{projectId}';
        this.GET_LIST_FILTERED = '/list/filtered';
    }

    async getUnreadCountByPhoneNumberIdAndProjectId(phoneNumberId, projectId) {
        try {
            let url = window.location.origin + this.WHATSAPP_CHATS_VIEW + this.GET_UNREAD_COUNT_BY_PHONE_NUMBER_ID_AND_PROJECT;
            url = url
                .replace('{phoneNumberId}', phoneNumberId)
                .replace('{projectId}', projectId);
            const contactUs = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return contactUs;
        } catch(err) {
            console.log(err);
        }
    }

    async getListFiltered(filterMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.WHATSAPP_CHATS_VIEW + this.GET_LIST_FILTERED;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filterMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default WhatsappChatsViewService;
